import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  grey2,
  grey5,
  grey6,
  grey10,
} from 'approot/shared/styles/colours.style';
import {
  spacing8,
  spacing24,
  spacing12,
} from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { InquisitiveBorderStyle } from 'global/graphql/scalars.type';
import { ACTIVITIES_BASE_HEIGHT_SMALL } from 'global/constants';
import {
  getBackgroundColour,
  getBorderColour,
  getFieldHeight,
} from './response.utils';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

type ResponseFieldProps = {
  $numberOfLines: number;
  $baseHeight: number | null;
  $isScaffoldedPlaceholder: boolean;
};
export const ResponseEditField = styled.div<ResponseFieldProps>`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}
  color: ${({ $isScaffoldedPlaceholder }) =>
    $isScaffoldedPlaceholder ? grey10 : grey6};
  display: flex;
  min-height: ${props =>
    rem(getFieldHeight(props.$numberOfLines, props.$baseHeight))};
  padding: ${({ $baseHeight }) =>
      $baseHeight === ACTIVITIES_BASE_HEIGHT_SMALL
        ? rem(spacing8)
        : rem(spacing8)}
    ${rem(spacing24)};

  ${({ $numberOfLines }) =>
    $numberOfLines === 1
      ? `
    align-items: center;
    `
      : `
    padding-top: ${rem(spacing12)};
  `};

  &:hover {
    cursor: not-allowed;
  }
`;

type ResponseProps = {
  variant?: InquisitiveBorderStyle | null;
  $isInEditFocus?: boolean;
  $baseColour: string | null;
};

export const ResponseBox = styled.div<ResponseProps>`
  background-color: ${grey2};
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius8)};
  position: relative;
  overflow: hidden;

  ${({ $baseColour }) =>
    $baseColour &&
    `
      background-color: ${getBackgroundColour($baseColour)};
      border-color: ${getBorderColour($baseColour)};
  `}

  ${({ $isInEditFocus }) =>
    $isInEditFocus &&
    `
    border-color: ${grey10};
  `}
`;

export const ResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing8)};
`;
